module.exports = __webpack_public_path__ + "static/img/tishi.64f42d09.svg";